export const S3_HOST = 'https://cdn.dom-ton.app';

// Common
export const cookieImage = `${S3_HOST}/common/cookie.webp`;
export const diamondIcon = `${S3_HOST}/common/icons/diamond.svg`;
export const diamondWhiteIcon = `${S3_HOST}/common/icons/diamondWhite.svg`;
export const checkIcon = `${S3_HOST}/common/icons/checkIcon.svg`;
export const defaultAvatarFemale = `${S3_HOST}/common/defaultAvatarFemale.webp`;
export const defaultAvatarMale = `${S3_HOST}/common/defaultAvatarMale.webp`;
export const wandIcon = `${S3_HOST}/common/icons/wand.svg`;
export const magicStickImage = `${S3_HOST}/common/magicStick.gif`;
export const questionIcon = `${S3_HOST}/common/icons/question.svg`;
export const diamondLightIcon = `${S3_HOST}/common/icons/diamondLight.svg`;
export const coinsIcon = `${S3_HOST}/common/icons/coins.svg`;
export const DOMLogo = `${S3_HOST}/common/DOMLogo.svg`;
export const loadAvatar = `${S3_HOST}/common/loadAvatar.webp`;
export const cakeIcon = `${S3_HOST}/common/icons/cake.svg`;
export const cakeLeftIcon = `${S3_HOST}/common/icons/cakeLeft.svg`;
export const cakeRightIcon = `${S3_HOST}/common/icons/cakeRight.svg`;
export const userCircleIcon = `${S3_HOST}/common/icons/userCircleIcon.svg`;
export const calendarImage = `${S3_HOST}/common/calendar.webp`;
export const moonImage = `${S3_HOST}/common/moon.webp`;
export const matrixPlaceholder = `${S3_HOST}/common/channelMockImage.webp`;
export const defaultImage = `${S3_HOST}/common/defaultImage.webp`;
export const giftImage = `${S3_HOST}/common/gift.webp`;
export const fortunePointer = `${S3_HOST}/common/fortunePointer.webp`;
export const fortuneWheel = `${S3_HOST}/common/fortuneWheel.webp`;
export const fortuneWheelEN = `${S3_HOST}/common/fortuneWheelEN.webp`;
export const settlementGift = `${S3_HOST}/common/settlementGift.webp`;
export const shareRef = `${S3_HOST}/common/shareRef.webp`;
export const sharePractices = `${S3_HOST}/common/sharePractices.webp`;

// Header
export const navbarDOMLogo = `${S3_HOST}/common/NavbarDOMLogo.svg`;
export const navbarDOMLogoBlack = `${S3_HOST}/common/icons/navbarDOMLogoBlack.svg`;

// Footer
export const diamondLargeIcon = `${S3_HOST}/common/icons/diamondLarge.svg`;
export const diamondLargeLightGrayIcon = `${S3_HOST}/common/icons/diamondLargeLightGray.svg`;
export const teamIcon = `${S3_HOST}/common/icons/team.svg`;
export const teamLightGrayIcon = `${S3_HOST}/common/icons/teamLightGray.svg`;
export const homeIcon = `${S3_HOST}/common/icons/home.svg`;
export const homeWhiteIcon = `${S3_HOST}/common/icons/homeWhite.svg`;
export const eyeIcon = `${S3_HOST}/common/icons/eye.svg`;
export const eyeLightGrayIcon = `${S3_HOST}/common/icons/eyeLightGray.svg`;
export const manDoingYogaIcon = `${S3_HOST}/common/icons/manDoingYoga.svg`;
export const manDoingYogaLightGrayIcon = `${S3_HOST}/common/icons/manDoingYogaLightGray.svg`;

// TON
export const creditCardIcon = `${S3_HOST}/common/icons/creditCardIcon.svg`;
export const marketLand = `${S3_HOST}/ton-market/land.webp`;
export const marketCamping = `${S3_HOST}/ton-market/camping.webp`;
export const marketHut = `${S3_HOST}/ton-market/hut.webp`;
export const marketCottage = `${S3_HOST}/ton-market/cottage.webp`;
export const marketFarm = `${S3_HOST}/ton-market/farm.webp`;
export const marketSpa = `${S3_HOST}/ton-market/spa.webp`;
export const marketTemple = `${S3_HOST}/ton-market/temple.webp`;
export const marketFit = `${S3_HOST}/ton-market/fit.webp`;
export const marketCoWorking = `${S3_HOST}/ton-market/co-working.webp`;
export const marketCafe = `${S3_HOST}/ton-market/healthy-cafe.webp`;
export const marketArt = `${S3_HOST}/ton-market/art-house.webp`;
export const marketAcademy = `${S3_HOST}/ton-market/academy.webp`;
export const marketBank = `${S3_HOST}/ton-market/bank.webp`;
export const marketBusiness = `${S3_HOST}/ton-market/business.webp`;
export const marketEmpire = `${S3_HOST}/ton-market/dom-empire.webp`;
export const marketIsland = `${S3_HOST}/ton-market/island.webp`;

// Market Packs
export const marketPack1 = `${S3_HOST}/ton-market/pack_1.webp`;
export const marketPack2 = `${S3_HOST}/ton-market/pack_2.webp`;
export const marketPack3 = `${S3_HOST}/ton-market/pack_3.webp`;
export const marketPack4 = `${S3_HOST}/ton-market/pack_4.webp`;
export const marketPack5 = `${S3_HOST}/ton-market/pack_5.webp`;

// Profile
export const instagramIcon = `${S3_HOST}/common/icons/instagram.svg`;
export const telegramIcon = `${S3_HOST}/common/icons/telegram.svg`;
export const adminIcon = `${S3_HOST}/common/icons/admin.svg`;

// Home
export const homeEllipseImage = `${S3_HOST}/home/homeEllipse.webp`;
export const homeRectangleImage = `${S3_HOST}/home/homeRectangle.webp`;
export const homeCalculatorIcon = `${S3_HOST}/home/homeCalculator.svg`;
export const homeLockIcon = `${S3_HOST}/home/homeLock.svg`;
export const homeMoonImage = `${S3_HOST}/home/homeMoon.webp`;

//Cognition
export const moonPhaseOneBg = `${S3_HOST}/cognition/moonPhase1.webp`;
export const moonPhaseTwoBg = `${S3_HOST}/cognition/moonPhase2.webp`;
export const cognitionModalImage = `${S3_HOST}/common/cognitionModalGeneral.webp`;

// Home slider
export const introduceImage = `${S3_HOST}/home-slider/introduce.webp`;
export const airDropImage = `${S3_HOST}/home-slider/air-drop.webp`;
export const villagesImage = `${S3_HOST}/home-slider/village.webp`;
export const presaleImage = `${S3_HOST}/home-slider/presale.webp`;
export const whatIsDomImage = `${S3_HOST}/home-slider/what.webp`;
export const payImage = `${S3_HOST}/home-slider/pay.webp`;
export const meetImage = `${S3_HOST}/home-slider/meet.webp`;
export const roadmapImage = `${S3_HOST}/home-slider/roadmap.webp`;

// Matrix
export const matrixIcon = `${S3_HOST}/matrix/matrix.svg`;
export const matrixConstructionImage = `${S3_HOST}/matrix/matrixConstruction.gif`;

// Settlements
export const walletIcon = `${S3_HOST}/common/icons/walletIcon.svg`;
export const landImage = `${S3_HOST}/settlements/land.webp`;
export const campingImage = `${S3_HOST}/settlements/camping.webp`;
export const cabinImage = `${S3_HOST}/settlements/cabin.webp`;
export const cottageImage = `${S3_HOST}/settlements/no-bg/cottage.webp`;
export const coworkingImage = `${S3_HOST}/settlements/co-working.webp`;
export const cafeImage = `${S3_HOST}/settlements/cafe.webp`;
export const farmImage = `${S3_HOST}/settlements/farm.webp`;
export const spaImage = `${S3_HOST}/settlements/spa.webp`;
export const templeImage = `${S3_HOST}/settlements/temple.webp`;
export const fitnessImage = `${S3_HOST}/settlements/fit.webp`;
export const parkImage = `${S3_HOST}/settlements/park.webp`;
export const beachImage = `${S3_HOST}/settlements/beach.webp`;
export const bankImage = `${S3_HOST}/settlements/bank.webp`;
export const businessCenterImage = `${S3_HOST}/settlements/business-center.webp`;
export const domEmpireImage = `${S3_HOST}/settlements/dom-empire.webp`;

// Settlement Details
export const campingBgImage = `${S3_HOST}/settlement-details/camping/bg.webp`;
export const campingBowlImage = `${S3_HOST}/settlement-details/camping/towel.webp`;
export const campingTowelImage = `${S3_HOST}/settlement-details/camping/bowl.webp`;

// Magic Cookies
export const TON1Image = `${S3_HOST}/cookies/1ton.webp`;
export const TON3Image = `${S3_HOST}/cookies/3ton.webp`;
export const TON10Image = `${S3_HOST}/cookies/10ton.webp`;
export const TON30Image = `${S3_HOST}/cookies/30ton.webp`;
export const TON77Image = `${S3_HOST}/cookies/77ton.webp`;
export const TON222Image = `${S3_HOST}/cookies/222ton.webp`;

// Pandas
export const eatingPandaImage = `${S3_HOST}/pandas/eatingPanda.webp`;
export const pandaWithCardImage = `${S3_HOST}/pandas/pandaWithCard.webp`;
export const richPandaImage = `${S3_HOST}/stones/modal/panda-rich.webp`;
export const pandaStonePoster = `${S3_HOST}/common/pandaStonePoster.webp`;
export const loadingPanda = `${S3_HOST}/pandas/loadingPanda.webp`;
export const pandaShadow = `${S3_HOST}/pandas/pandaShadow.svg`;
export const pandaHelloImage = `${S3_HOST}/pandas/pandaHello.webp`;
export const pandaBroom = `${S3_HOST}/pandas/pandaBroom.webp`;
export const developPandasImage = `${S3_HOST}/pandas/instructions/developPandas.webp`;
export const pandaFaceImage = `${S3_HOST}/pandas/pandaFace.webp`;
export const wisdomPanda = `${S3_HOST}/pandas/wisdomPanda.webp`;
export const twoPandasFriendsImage = `${S3_HOST}/pandas/pandasFriends.webp`;
export const pandaEatsCookiesImage = `${S3_HOST}/pandas/pandaEatsCookies.webp`;
export const defaultPandaImage = `${S3_HOST}/pandas/1/level1-unisex1.webp`;
export const pandaHand = `${S3_HOST}/pandas/pandaHand.webp`;
export const playerMeditationPanda = `${S3_HOST}/pandas/playerMeditationPanda.webp`;
export const playerInsightsPanda = `${S3_HOST}/pandas/playerInsightsPanda.webp`;

// Stones
export const firstStoneImage = `${S3_HOST}/stones/1stStone.webp`;
export const secondStoneImage = `${S3_HOST}/stones/2ndStone.webp`;
export const fourthStoneImage = `${S3_HOST}/stones/4thStone.webp`;

// Instructions
export const firstInstructionSettlement = `${S3_HOST}/settlements/instructions/first.webp`;
export const secondInstructionSettlement = `${S3_HOST}/settlements/instructions/second.webp`;
export const thirdInstructionSettlement = `${S3_HOST}/settlements/instructions/third.webp`;
export const prizeImage = `${S3_HOST}/common/prize.webp`;
export const wishCookieIcon = `${S3_HOST}/common/icons/wishCookie.svg`;

// Daily cards
export const taroCardsImage = `${S3_HOST}/common/taroCards.webp`;
export const taroCardOneIcon = `${S3_HOST}/taro-cards/taroCard1.svg`;
export const taroCardTwoIcon = `${S3_HOST}/taro-cards/taroCard2.svg`;
export const taroCardThreeIcon = `${S3_HOST}/taro-cards/taroCard3.svg`;
export const defaultTaroCardImage = `${S3_HOST}/taro-cards/defaultTaroCard.webp`;
export const taroPandasImage = `${S3_HOST}/taro-cards/taroPandas.webp`;

// Daily energy
export const starryBgImage = `${S3_HOST}/daily-energy/starryEnergyBg.webp`;

export const craneIcon = `${S3_HOST}/daily-energy/crane.svg`;
export const newMoonIcon = `${S3_HOST}/daily-energy/newMoon.svg`;
export const waxingMoonIcon = `${S3_HOST}/daily-energy/waxingMoon.svg`;
export const fullMoonIcon = `${S3_HOST}/daily-energy/fullMoon.svg`;
export const waningMoonIcon = `${S3_HOST}/daily-energy/waningMoon.svg`;

export const AUTHENTICATED_LAYOUT_PRELOAD_IMAGES = [
  // Header
  navbarDOMLogo,
  navbarDOMLogoBlack,
  cookieImage,
  diamondIcon,
  defaultAvatarFemale,
  defaultAvatarMale,
  // Footer
  homeIcon,
  homeWhiteIcon,
  diamondLargeIcon,
  diamondLargeLightGrayIcon,
  teamIcon,
  teamLightGrayIcon,
  eyeIcon,
  eyeLightGrayIcon,
  manDoingYogaIcon,
  manDoingYogaLightGrayIcon,
  // DailyRewardModal
  eatingPandaImage,
  cakeIcon,
];

export const USER_DATA_FORM_PRELOAD_IMAGES = [
  ...AUTHENTICATED_LAYOUT_PRELOAD_IMAGES,
  pandaHelloImage,
];

export const INSTRUCTIONS_PRELOAD_IMAGES = [
  // DevelopSection
  developPandasImage,
  // StonesSection
  firstStoneImage,
  secondStoneImage,
  fourthStoneImage,
  // ExpandSection
  firstInstructionSettlement,
  secondInstructionSettlement,
  thirdInstructionSettlement,
  // CompetitionSection
  prizeImage,
  // LevelUpSection
  wishCookieIcon,
];

export const HOME_PRELOAD_IMAGES = [
  ...AUTHENTICATED_LAYOUT_PRELOAD_IMAGES,
  // TopSection
  homeEllipseImage,
  homeRectangleImage,
  homeCalculatorIcon,
  cookieImage,
  defaultPandaImage,
  // SettlementsSection
  diamondIcon,
  homeLockIcon,
  // FeedPandaModal
  eatingPandaImage,
  cakeLeftIcon,
  cakeRightIcon,
  pandaFaceImage,
];

export const SHOP_PRELOAD_IMAGES = [
  // magic cookies section
  cookieImage,
  // settlements section
  diamondIcon,
  defaultImage,
  // PandoraBankSection
  pandaWithCardImage,
  questionIcon,
  // ShopModal
  eatingPandaImage,
  richPandaImage,
  cottageImage,
];

export const COOKIES_SHOP_PRELOAD_IMAGES = [
  TON1Image,
  TON3Image,
  TON10Image,
  TON30Image,
  TON77Image,
  TON222Image,
  cookieImage,
];

export const DIAMONDS_SHOP_PRELOAD_IMAGES = [
  diamondIcon,
  defaultAvatarFemale,
  defaultAvatarMale,
  navbarDOMLogoBlack,
  creditCardIcon,
];

export const COGNITION_PRELOAD_IMAGES = [
  // CarouselSection
  airDropImage,
  introduceImage,
  meetImage,
  payImage,
  presaleImage,
  roadmapImage,
  villagesImage,
  whatIsDomImage,
  // StonesBanner
  wisdomPanda,
  diamondWhiteIcon,
  // DailyBannersSection
  moonPhaseOneBg,
  moonPhaseTwoBg,
];

export const STONE_ABILITIES_PRELOAD_IMAGES = [cognitionModalImage, cookieImage];

export const TASKS_PRELOAD_IMAGES = [eatingPandaImage, checkIcon, cookieImage, cakeIcon];

export const MATRIX_CHANNEL_PRELOAD_IMAGES = [matrixPlaceholder];

export const ROADMAP_PRELOAD_IMAGES = [coinsIcon];

export const DAILY_CARD_PREVIEW_PRELOAD_IMAGES = [
  taroCardsImage,
  wandIcon,
  taroCardOneIcon,
  taroCardTwoIcon,
  taroCardThreeIcon,
];

export const DAILY_ENERGY_PRELOAD_IMAGES = [starryBgImage, questionIcon, craneIcon];

export const DAILY_ENERGY_DESCRIPTION_PRELOAD_IMAGES = [
  newMoonIcon,
  waxingMoonIcon,
  fullMoonIcon,
  waningMoonIcon,
];

export const COMPATIBILITY_PRELOAD_IMAGES = [eatingPandaImage, defaultPandaImage];
